import { render, staticRenderFns } from "./AstraTopElementIsMainTableColumn.vue?vue&type=template&id=5a3636c2&scoped=true"
import script from "./AstraTopElementIsMainTableColumn.vue?vue&type=script&lang=js"
export * from "./AstraTopElementIsMainTableColumn.vue?vue&type=script&lang=js"
import style0 from "./AstraTopElementIsMainTableColumn.vue?vue&type=style&index=0&id=5a3636c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3636c2",
  null
  
)

export default component.exports